
import { useContext, useEffect, useRef, useState } from 'react';

import styles from './PD_ConferenceComponent.module.css'

import { ProjectDetailsContext } from "../../../contexts/projectDetailsContext";
import { GlobalContext } from "../../../contexts/globalContext";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';

import LightButtonComponent from '../../commons/LightButtonComponent';
import TagComponent from '../../projectList/TagComponent';
import DetailCountComponent from '../../projectList/DetailCountComponent';

const PD_ConferenceComponent = ({ conference }) => {

    const {
        setConferencePaused, setWaitingForJoining, socketRef, currentUser, selectedProject, detailsUpcomingConference, setCurrentConference, setCurrentParticipant, deskData,
        appWidth, appHeight
    } = useContext(GlobalContext);

    const { setEditConference, setDeleteClicked } = useContext(ProjectDetailsContext);

    const deleteRef = useRef()

    const [showStartPresentation, setShowStartPresentation] = useState(false);
    const [showJoinButton, setShowJoinButton] = useState(false);

    const date = new Date(conference.scheduleDate)

    const oxDivider = window.innerWidth / appWidth;
    const oyDivider = window.innerHeight / appHeight;

    useEffect(() => {
        var isMeetingActive = conference.type === "Meeting";

        if (isMeetingActive) {
            var start = true

            const today = new Date()
            const scheduleDate = new Date(conference.scheduleDate)
            const endScheduleDate = new Date(conference.endScheduleDate)
            const startDate = new Date(scheduleDate.getTime() - 600000)

            if (today < startDate || today > endScheduleDate) {
                isMeetingActive = false;
                start = false
            }

            if (conference.status !== "Active") {
                isMeetingActive = false;
            }

            if (conference.status !== "New") {
                start = false;
            }

            setShowJoinButton(isMeetingActive);
            setShowStartPresentation(start)

        } else {
            if (!conference.attachedParticipants.some((item) => item.participant === currentUser._id)) {
                setShowJoinButton(false);
            } else {
                setShowJoinButton(conference.status === "Active");
            }

        }
    }, [conference])

    function deleteConference() {
        socketRef.current.emit("DELETE_CONFERENCE", conference._id, selectedProject._id, () => {
            setDeleteClicked()
        })
    }

    function selectConference() {
        socketRef.current.emit("GET_CONFERENCE_BY_ID", conference._id, (callback) => {
            setEditConference(callback.response)
        })
    }

    const handleDelete = (e) => {
        e.stopPropagation();
        if (!deleteRef.current) return;

        const rect = deleteRef.current.getBoundingClientRect();

        let x = rect.x
        let y = rect.y

        if (x / oxDivider - 1024 + 739 > appWidth) {
            x = (appWidth - 760) * oxDivider
        }

        if (y / oyDivider + 255 > appHeight) {
            y = (appHeight - 275) * oyDivider
        }

        setDeleteClicked({
            shown: true,
            funct: deleteConference,
            name: conference.type,
            x: x + 90,
            y: y,
            onClose: () => setDeleteClicked(),
        });
    };

    const Start = () => {
        if (conference.type === "Meeting" && conference.status !== "Active") {
            socketRef.current.emit("START_CONFERENCE", conference._id, conference.code, currentUser._id, () => {
                setCurrentParticipant(currentUser);
                setCurrentConference({ ...conference, status: "Active" });
                if (conference.type === "Meeting" && deskData) {
                    setWaitingForJoining(false);
                }
                socketRef.current.emit("PRESENTATION_STARTED", conference);
            });
        } else {
            socketRef.current.emit("START_CONFERENCE", conference._id, conference.code, null, async (data) => {
                if (!data.error) {
                    socketRef.current.emit("PRESENTATION_STARTED", conference);
                    socketRef.current.emit("GET_NEXT_OR_ACTIVE_CONFERENCE", deskData._id, (data) => {
                        if (!data.error && data.conference) {
                            if (data.conference.status === "Active") {
                                setWaitingForJoining(false);
                            }
                            setCurrentParticipant(data.participant);
                            setCurrentConference(data.conference);
                            setConferencePaused(data.conference.paused);
                            setConferencePaused(false);
                        }
                    });
                }
            });
        }

    };

    useEffect(() => {
        var firstModerator = false;
        var onCorrectDesk = false;

        if (conference.topics?.length > 0 && conference.topics[0].moderator._id === currentUser.id) {
            firstModerator = true;
        }

        if (conference.attachedParticipants && deskData) {
            var ap_found = conference.attachedParticipants.find(element => element.participant === currentUser._id && element.desk === deskData._id);
            if (ap_found) {
                onCorrectDesk = true;
            }
        }

        if ((conference.status === "New" || conference.status === "Done") && conference.type === "Presentation" && firstModerator && onCorrectDesk) {
            setShowStartPresentation(true);
        }

    }, [selectedProject])

    const Join = () => {
        // if (conference.type === "Meeting" && conference.status !== "Active") {
        //     socketRef.current.emit("START_CONFERENCE", conference._id, conference.code, currentUser._id, () => {
        //         setCurrentParticipant(currentUser);
        //         setCurrentConference(conference);
        //         if (conference.type === "Meeting" && deskData) {
        //             setWaitingForJoining(false);
        //         }
        //     });
        // } else {
        setCurrentParticipant(currentUser);
        setCurrentConference(conference);
        if (conference.type === "Meeting" && deskData) {
            setWaitingForJoining(false);
        }
        // }
    }

    const verifyDisplay = () => {
        if (conference.type === "Conference" && conference.moderatedBy && conference.roomAdmins) {
            const allNull = Object.values(conference.roomAdmins).every(value => value === null);

            if (allNull && conference.moderatedBy !== currentUser._id) {
                return "none"
            }
        }

        return "block"
    }

    return (
        <div className={(new Date(conference.endScheduleDate) < new Date() || conference.status === "Done") && conference.type !== "Presentation" ? styles.pastElement : styles.element}
            style={{
                background: conference.type !== "Meeting" ? "" : ((new Date(conference.endScheduleDate) >= new Date() && conference.status !== "Done")
                    ? "#2D2748 0% 0% no-repeat padding-box" : "#231A3E80 0% 0% no-repeat padding-box"),
                borderColor: conference.type === "Conference" ? "#6CEA7F" : "#E56ADB",
                borderWidth: conference.status === "Active" ? "2px" : "0px",
                display: verifyDisplay()
            }}>
            <div className={styles.info}>
                <div>
                    <div className={styles.title_tags}>
                        <TagComponent status={conference.type} text={conference.type} />
                        {conference.type !== "Presentation" && <>
                            {new Date(conference.endScheduleDate) >= new Date() && detailsUpcomingConference?._id !== conference._id && conference.status !== "Done" &&
                                <TagComponent status="active" text="Future" />}
                            {(new Date(conference.endScheduleDate) < new Date() || conference.status === "Done") &&
                                <TagComponent status="inactive" text="Past" />}
                            {detailsUpcomingConference?._id === conference._id &&
                                <TagComponent status="live" text="Upcoming" />
                            }
                        </>}
                    </div>
                    <div style={{ marginTop: 10 }}>{conference.name}</div>
                </div>
                {!showJoinButton &&
                    <FontAwesomeIcon
                        className={styles.iconButton}
                        style={{ right: currentUser?.role.toLowerCase() === "administrator" ? 115 : 60, fontSize: 32, top: 50 }}
                        icon={byPrefixAndName.fal['pen']}
                        onClick={() => selectConference()}
                    />
                }
                {!showJoinButton && currentUser?.role.toLowerCase() === "administrator" && (
                    <FontAwesomeIcon
                        ref={deleteRef}
                        className={styles.iconButton}
                        style={{ right: 50, fontSize: 32, top: 50 }}
                        icon={byPrefixAndName.fal['trash']}
                        onClick={(e) => handleDelete(e)}
                    />
                )}
            </div>
            {conference.type !== "Presentation" && <div className={styles.details}>
                <div className={styles.half_detail} style={{ borderRight: "2px solid #FFFFFF33" }}>
                    <div style={{ color: "#CDCCD2" }}>
                        <FontAwesomeIcon className={styles.icon} icon={byPrefixAndName.fal['calendar-days']} />
                        Date
                    </div>
                    <div className={styles.detail_accent}>
                        {date.toLocaleDateString('en-RO', { weekday: 'short' })} {date.toLocaleDateString('en-RO', { day: '2-digit' })} {date.toLocaleDateString('en-RO', { month: 'short' })}
                    </div>
                </div>
                <div className={styles.half_detail} >
                    <div style={{ color: "#CDCCD2" }}>
                        <FontAwesomeIcon className={styles.icon} icon={byPrefixAndName.fal['clock']} />
                        Starting at
                    </div>
                    <div className={styles.detail_accent}>
                        {date.toLocaleTimeString('en-RO', { hour12: false, hour: '2-digit', minute: '2-digit' })}
                    </div>
                </div>
            </div>
            }
            <div className={styles.line}></div>
            <div className={styles.moreInfo} style={{ color: "#CDCCD2" }}>
                {conference.type !== 'Meeting' && <DetailCountComponent project={conference} type={"nrTopics"}
                    style={{ 
                        font: "normal normal normal 28px/42px 'Bio Sans'", 
                        opacity: (new Date(conference.endScheduleDate) < new Date() || conference.status === "Done") && conference.type !== "Presentation" ? 0.5 : 1 
                    }} />}
                {conference.type !== 'Presentation' && <DetailCountComponent project={conference} type={"nrAttachedParticipants"}
                    style={{ font: "normal normal normal 28px/42px 'Bio Sans'", opacity: new Date(conference.endScheduleDate) < new Date() || conference.status === "Done" ? 0.5 : 1 }} />}
                {conference.type === 'Conference' && <DetailCountComponent project={conference} type={"nrModerators"}
                    style={{ font: "normal normal normal 28px/42px 'Bio Sans'", opacity: new Date(conference.endScheduleDate) < new Date() || conference.status === "Done" ? 0.5 : 1 }} />}
            </div>

            {showJoinButton &&
                <div className={styles.buttons}>
                    <LightButtonComponent onClick={Join}
                        style={{ font: "normal normal 600 40px/80px 'Bio Sans'", marginLeft: 0 }}>
                        <FontAwesomeIcon className={styles.iconArrow} icon={byPrefixAndName.fas['arrow-right']} />
                        {/* {conference.type === "Meeting" && conference.status !== "Active" ? "START" : "JOIN"} */}
                        JOIN
                    </LightButtonComponent>
                </div>
            }

            {showStartPresentation &&
                <div className={styles.buttons}>
                    <LightButtonComponent onClick={Start}
                        style={{ font: "normal normal 600 40px/80px 'Bio Sans'", marginLeft: 0 }}>
                        <FontAwesomeIcon className={styles.iconArrow} icon={byPrefixAndName.fas['arrow-right']} />
                        START
                    </LightButtonComponent>
                </div>
            }
        </div >
    );

}



export default PD_ConferenceComponent;